import { render, staticRenderFns } from "./CustomerInformationV2026.vue?vue&type=template&id=28c7019e&scoped=true"
import script from "./CustomerInformationV2026.vue?vue&type=script&lang=js"
export * from "./CustomerInformationV2026.vue?vue&type=script&lang=js"
import style0 from "./CustomerInformationV2026.vue?vue&type=style&index=0&id=28c7019e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c7019e",
  null
  
)

export default component.exports